import './App.css';
import GetObjects from './Components/Get Objects';
import GetFields from './Components/GetFields';

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <GetObjects></GetObjects>
      <GetFields></GetFields>
      </header>
    </div>
  );
}

export default App;
